import "./styles.css";
//import "bootstrap/dist/css/bootstrap.css";
import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";

import { router } from "./router/index.jsx";
import PL2State from "./reducers/index.js";
import { LoadingSuspense } from "./common/loaders/loadingsuspense.jsx";

export const hrEsalary = "hr.esalary.fi";

export const store = configureStore({
  reducer: PL2State,
  devTools: import.meta.env.DEV,
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Suspense fallback={<LoadingSuspense />}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <RouterProvider router={router} />
        </Provider>
      </QueryClientProvider>
    </Suspense>
  </StrictMode>,
);
